import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

export function Privacy() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const sections: ReadonlyArray<{ key: string; body: string }> = [
    { key: 'rpcNodes', body: t('privacy.rpcNodes') },
    { key: 'booster', body: t('privacy.booster') },
    { key: 'browser', body: t('privacy.browser') },
    { key: 'tma', body: t('privacy.tma') },
    { key: 'noCollection', body: t('privacy.noCollection') },
  ];

  return (
    <div className="flex min-h-screen flex-col bg-bg px-5 pb-6 pt-3 text-text-primary">
      <div className="flex items-center justify-between py-2">
        <button type="button" onClick={() => navigate(-1)} className="text-link text-[15px]">
          ‹ {t('common.back')}
        </button>
        <div className="text-[16px] font-semibold text-text-primary">{t('privacy.title')}</div>
        <div style={{ width: 36 }} />
      </div>
      <div className="mt-4 flex-1 rounded-xl bg-surface-1 p-4 text-[13px] leading-relaxed text-text-secondary">
        {sections.map((s) => (
          <p key={s.key} className="mb-3 last:mb-0">
            {s.body}
          </p>
        ))}
      </div>
    </div>
  );
}
